import request from '../utils/request';

//首页
export function getHome(data) {
    return request({
        url: 'home/home/main',
        method: 'post',
        data: data,
    });
}
//需求列表
export function bookList(data) {
    return request({
        url: 'home/book/list',
        method: 'post',
        data: data,
    });
}
//需求
export function bookStatus(data) {
    return request({
        url: '/home/book/up_status',
        method: 'post',
        data: data,
    });
}

//用户
export function userList(data) {
    return request({
        url: '/home/user/list',
        method: 'post',
        data: data,
    });
}
//获取验证码
export function getCode(data) {
    return request({
        url: 'home/sms/send',
        method: 'post',
        data: data,
    });
}
//重置账号密码
export function resetPassword(data) {
    return request({
        url: 'home/admin/reset_password',
        method: 'post',
        data: data,
    });
}
//绑定微信
export function bandWx(data) {
    return request({
        url: '/home/admin/bind_wx',
        method: 'post',
        data: data,
    });
}
//提现申请
export function addBank(data) {
    return request({
        url: 'home/bank/add',
        method: 'post',
        data: data,
    });
}

//需求处理
export function bookUp_status(data) {
    return request({
        url: 'home/book/up_status',
        method: 'post',
        data: data,
    });
}

//更新用户状态
export function updateUserData(data) {
    return request({
        url: 'home/user/up_status',
        method: 'post',
        data: data,
    });
}
//更新用户信息
export function updateUserInfo(data) {
    return request({
        url: 'home/user/up_info',
        method: 'post',
        data: data,
    });
}

//获取账号列表
export function getAdminList(data) {
    return request({
        url: 'home/admin/list',
        method: 'post',
        data: data,
    });
}
//更新账号状态
export function updateAdmin(data) {
    return request({
        url: 'home/admin/up_status',
        method: 'post',
        data: data,
    });
}

//设置平台安全手机号
export function setRoleMobile(data) {
    return request({
        url: 'home/admin/set_sys_mobile',
        method: 'post',
        data: data,
    });
}
//获取平台安全手机号
export function getRoleMobile(data) {
    return request({
        url: 'home/admin/set_sys_mobile',
        method: 'get',
        data: data,
    });
}
//安全日志
export function getLog(data) {
    return request({
        url: 'home/home/log',
        method: 'get',
        data: data,
    });
}
